module.exports = __webpack_public_path__ + "assets/img/tit6.71e7f9e4.png";